export enum BibliographicResourceType {
  Article = 'Article',
  AudioDocument = 'AudioDocument',
  AudioVisualDocument = 'AudioVisualDocument',
  Book = 'Book',
  Chapter = 'Chapter',
  Database = 'Database',
  Document = 'Document',
  Image = 'Image',
  Journal = 'Journal',
  LegalCaseDocument = 'LegalCaseDocument',
  LegalDocument = 'LegalDocument',
  Legislation = 'Legislation',
  Score = 'Score', // Put alphabetically before Newspaper as the UI label is 'Music Score'
  Newspaper = 'Newspaper',
  Page = 'Page',
  PhysicalResource = 'PhysicalResource',
  Proceedings = 'Proceedings',
  Report = 'Report',
  Thesis = 'Thesis',
  Webpage = 'Webpage',
  Website = 'Website',
}

/*
 * Unstable resources are enabled via the Setup Console 'Misc' tab.
 */
export const UnstableBibliographicResourceTypes: BibliographicResourceType[] =
  [];

export const BibliographicResourceTypeLocaleLabels: Record<
  BibliographicResourceType,
  string
> = {
  [BibliographicResourceType.Article]: $localize`:@@bibliographicResourceTypeArticle:Article`,
  [BibliographicResourceType.AudioDocument]: $localize`:@@bibliographicResourceTypeAudioDocument:Audio Document`,
  [BibliographicResourceType.AudioVisualDocument]: $localize`:@@bibliographicResourceTypeAudioVisualDocument:Audio-visual Document`,
  [BibliographicResourceType.Book]: $localize`:@@bibliographicResourceTypeBook:Book`,
  [BibliographicResourceType.Chapter]: $localize`:@@bibliographicResourceTypeChapter:Chapter`,
  [BibliographicResourceType.Database]: $localize`:@@bibliographicResourceTypeDatabase:Database`,
  [BibliographicResourceType.Document]: $localize`:@@bibliographicResourceTypeDocument:Document`,
  [BibliographicResourceType.Image]: $localize`:@@bibliographicResourceTypeImage:Image`,
  [BibliographicResourceType.Journal]: $localize`:@@bibliographicResourceTypeJournal:Journal`,
  [BibliographicResourceType.LegalCaseDocument]: $localize`:@@bibliographicResourceTypeLegalCaseDocument:Legal Case Document`,
  [BibliographicResourceType.LegalDocument]: $localize`:@@bibliographicResourceTypeLegalDocument:Legal Document`,
  [BibliographicResourceType.Legislation]: $localize`:@@bibliographicResourceTypeLegislation:Legislation`,
  [BibliographicResourceType.Newspaper]: $localize`:@@bibliographicResourceTypeNewspaper:Newspaper`,
  [BibliographicResourceType.Page]: $localize`:@@bibliographicResourceTypePage:Page`,
  [BibliographicResourceType.PhysicalResource]: $localize`:@@bibliographicResourceTypePhysicalResource:Object`,
  [BibliographicResourceType.Proceedings]: $localize`:@@bibliographicResourceTypeProceedings:Proceedings`,
  [BibliographicResourceType.Report]: $localize`:@@bibliographicResourceTypeReport:Report`,
  [BibliographicResourceType.Score]: $localize`:@@bibliographicResourceTypeScore:Music Score`,
  [BibliographicResourceType.Thesis]: $localize`:@@bibliographicResourceTypeThesis:Thesis`,
  [BibliographicResourceType.Webpage]: $localize`:@@bibliographicResourceTypeWebpage:Webpage`,
  [BibliographicResourceType.Website]: $localize`:@@bibliographicResourceTypeWebsite:Website`,
};

export const ALL_BIBLIOGRAPHIC_RESOURCE_TYPES: BibliographicResourceType[] =
  Object.keys(BibliographicResourceType).map(
    key => BibliographicResourceType[key],
  );

export const STABLE_BIBLIOGRAPHIC_RESOURCE_TYPES: BibliographicResourceType[] =
  Object.keys(BibliographicResourceType).filter(
    (
      bibliographicResourceType: BibliographicResourceType,
    ): bibliographicResourceType is BibliographicResourceType =>
      !UnstableBibliographicResourceTypes.includes(bibliographicResourceType),
  );
